function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { forwardRef } from "react";
import Label from "../Label/index";
import useStyle from "./Switch.style";
import { resolveIds } from "../../utils";
import HelperText from "../HelperText/index";
var Switch = forwardRef(function(_param, ref) {
    var css = _param.css, disabled = _param.disabled, isDisabled = _param.isDisabled, helperText = _param.helperText, hideLabel = _param.hideLabel, id = _param.id, isRtl = _param.isRtl, labelText = _param.labelText, onClick = _param.onClick, onUpdate = _param.onUpdate, isRequired = _param.isRequired, labelRequiredTitle = _param.labelRequiredTitle, style = _param.style, testID = _param.testID, value = _param.value, propDrop = _objectWithoutProperties(_param, [
        "css",
        "disabled",
        "isDisabled",
        "helperText",
        "hideLabel",
        "id",
        "isRtl",
        "labelText",
        "onClick",
        "onUpdate",
        "isRequired",
        "labelRequiredTitle",
        "style",
        "testID",
        "value"
    ]);
    var _$ref;
    var _$ref1 = useStyle({
        on: value,
        disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled,
        isRtl: isRtl
    }), trackStyles = _$ref1.trackStyles, thumbStyles = _$ref1.thumbStyles, container = _$ref1.container, buttonContainer = _$ref1.buttonContainer;
    var handleClick = function(event) {
        if (typeof onUpdate === 'function') {
            onUpdate(!value);
        }
        if (typeof onClick === 'function') {
            onClick(event);
        }
    };
    var _$ref2 = resolveIds(id, testID, 'helper-text', true), helperTextId = _$ref2.id, helperTextTestID = _$ref2.testID;
    return _jsxs("div", {
        css: container,
        children: [
            id && labelText && _jsx(Label, _objectSpread({
                htmlFor: id,
                isDisabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled,
                isHidden: hideLabel,
                isRequired: isRequired,
                isRtl: isRtl,
                requiredTitle: labelRequiredTitle,
                variant: "default"
            }, resolveIds(id, testID, 'label', true), {
                children: labelText
            })),
            _jsx("div", {
                css: buttonContainer,
                children: _jsx("button", _objectSpread({
                    type: "button"
                }, propDrop, {
                    id: id,
                    "aria-labelledby": (_$ref = resolveIds(id, testID, 'label', true)) === null || _$ref === void 0 ? void 0 : _$ref.id,
                    css: [
                        trackStyles,
                        css
                    ],
                    onClick: handleClick,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : disabled,
                    ref: ref,
                    "aria-describedby": [
                        propDrop === null || propDrop === void 0 ? void 0 : propDrop['aria-describedby'],
                        id && helperText && helperTextId
                    ].filter(Boolean).join(' ') || undefined,
                    children: _jsx("div", {
                        css: thumbStyles
                    })
                }))
            }),
            id && _jsx(HelperText, {
                id: helperTextId,
                isRtl: isRtl,
                testID: helperTextTestID,
                children: helperText
            })
        ]
    });
});
export { Switch };
export default Switch;
